export const SET_STATUS_CODE = 'SET_STATUS_CODE';

export const setStatusCode = (status) => ({
  type: SET_STATUS_CODE,
  status,
});
